module.exports = __webpack_public_path__ + "img/story_img2.d5d3a159.jpg";